
//v4
// src/components/chart8.js

import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const DoughnutChart = ({ value = 0, label = "", size = "large" }) => {
  const pct = Math.max(0, Math.min(100, Number(value) || 0)); // 0–100

  const data = {
    datasets: [
      {
        data: [pct, 100 - pct],
        backgroundColor: ["#0084ff", "#e5e7eb"],
        borderWidth: 0,
        cutout: size === "large" ? "70%" : "75%",
      },
    ],
  };

  const options = {
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
    maintainAspectRatio: false,
  };

  return (
    <div className={`doughnut-wrapper ${size}`}>
      <Doughnut data={data} options={options} />
      <div className="doughnut-center">
        <span className="doughnut-value">
          {pct.toFixed(2)}%
        </span>
        <span className="doughnut-label">
          {label}
        </span>
      </div>
    </div>
  );
};

export default DoughnutChart;

